var _rect, _rect2, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEikow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 28,
    viewBox: "0 0 67 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 66,
    height: 27,
    rx: 13.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 66,
    height: 27,
    rx: 13.5,
    stroke: "url(#paint0_linear_2791_13091)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1465 20.1826C14.2445 20.1826 13.4697 19.9917 12.8223 19.6099C12.1803 19.228 11.6851 18.6857 11.3364 17.9829C10.9878 17.2801 10.8135 16.4473 10.8135 15.4844V15.4761C10.8135 14.5243 10.985 13.6942 11.3281 12.9858C11.6768 12.2775 12.1693 11.7297 12.8057 11.3423C13.4421 10.9494 14.1891 10.7529 15.0469 10.7529C15.9102 10.7529 16.6517 10.9438 17.2715 11.3257C17.8968 11.702 18.3783 12.2305 18.7158 12.9111C19.0534 13.5918 19.2222 14.3887 19.2222 15.3018V15.9824H11.8511V14.5962H18.2095L17.23 15.8911V15.0693C17.23 14.4661 17.1387 13.9653 16.9561 13.5669C16.7734 13.1685 16.5189 12.8696 16.1924 12.6704C15.8714 12.4712 15.4979 12.3716 15.0718 12.3716C14.6457 12.3716 14.2666 12.4767 13.9346 12.687C13.6081 12.8918 13.348 13.1961 13.1543 13.6001C12.9661 13.9985 12.8721 14.4883 12.8721 15.0693V15.8994C12.8721 16.4583 12.9661 16.937 13.1543 17.3354C13.3424 17.7284 13.6081 18.0327 13.9512 18.2485C14.2998 18.4588 14.7121 18.564 15.188 18.564C15.5588 18.564 15.877 18.5114 16.1426 18.4062C16.4137 18.2956 16.6323 18.1655 16.7983 18.0161C16.9644 17.8612 17.0806 17.7145 17.147 17.5762L17.1719 17.5181H19.1309L19.1143 17.5928C19.0423 17.8861 18.9095 18.1849 18.7158 18.4893C18.5277 18.7881 18.2703 19.0675 17.9438 19.3276C17.6229 19.5822 17.23 19.7897 16.7651 19.9502C16.3003 20.1051 15.7607 20.1826 15.1465 20.1826ZM20.974 20V10.9272H23.0326V20H20.974ZM22.0116 9.4082C21.674 9.4082 21.3835 9.28923 21.14 9.05127C20.8965 8.81331 20.7747 8.52832 20.7747 8.19629C20.7747 7.85319 20.8965 7.56543 21.14 7.33301C21.3835 7.09505 21.674 6.97607 22.0116 6.97607C22.3491 6.97607 22.6369 7.09505 22.8748 7.33301C23.1183 7.56543 23.2401 7.85319 23.2401 8.19629C23.2401 8.52832 23.1183 8.81331 22.8748 9.05127C22.6369 9.28923 22.3491 9.4082 22.0116 9.4082ZM25.3239 20V7.41602H27.3908V20H25.3239ZM31.0265 20L27.9719 15.8828L29.5075 14.6211L33.5085 20H31.0265ZM27.2165 16.9951L27.1418 14.6543H27.5319L30.8771 10.9272H33.2678L29.3249 15.0693L28.3786 15.8081L27.2165 16.9951ZM38.1821 20.1826C37.2801 20.1826 36.5026 19.9945 35.8496 19.6182C35.1966 19.2363 34.6931 18.694 34.3389 17.9912C33.9903 17.2884 33.8159 16.4473 33.8159 15.4678V15.4512C33.8159 14.4827 33.993 13.6471 34.3472 12.9443C34.7014 12.236 35.2022 11.6937 35.8496 11.3174C36.5026 10.9411 37.2801 10.7529 38.1821 10.7529C39.0842 10.7529 39.8589 10.9411 40.5064 11.3174C41.1594 11.6937 41.6629 12.2332 42.0171 12.936C42.3713 13.6388 42.5484 14.4772 42.5484 15.4512V15.4678C42.5484 16.4473 42.3713 17.2884 42.0171 17.9912C41.6685 18.694 41.1677 19.2363 40.5147 19.6182C39.8672 19.9945 39.0897 20.1826 38.1821 20.1826ZM38.1821 18.5059C38.6581 18.5059 39.062 18.3869 39.3941 18.1489C39.7316 17.9054 39.989 17.5596 40.166 17.1113C40.3431 16.6576 40.4317 16.1125 40.4317 15.4761V15.4595C40.4317 14.8175 40.3431 14.2725 40.166 13.8242C39.989 13.3704 39.7316 13.0246 39.3941 12.7866C39.062 12.5431 38.6581 12.4214 38.1821 12.4214C37.7062 12.4214 37.2995 12.5431 36.9619 12.7866C36.6244 13.0246 36.367 13.3704 36.19 13.8242C36.0129 14.2725 35.9243 14.8175 35.9243 15.4595V15.4761C35.9243 16.1125 36.0129 16.6576 36.19 17.1113C36.367 17.5651 36.6216 17.911 36.9536 18.1489C37.2912 18.3869 37.7007 18.5059 38.1821 18.5059ZM45.6532 20L43.1879 10.9272H45.263L46.7655 17.7505H46.9149L48.6581 10.9272H50.6254L52.3768 17.7505H52.5262L54.0287 10.9272H56.079L53.6136 20H51.4554L49.6874 13.4258H49.5462L47.7865 20H45.6532Z",
    fill: "url(#paint1_linear_2791_13091)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2791_13091",
    x1: -4.72564e-7,
    y1: 28.5,
    x2: 67,
    y2: 0.00000100573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC736D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.142476,
    stopColor: "#DB5D58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E85576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.446912,
    stopColor: "#E4489C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.580759,
    stopColor: "#BE45AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#7B44BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855,
    stopColor: "#5671EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#739BF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2791_13091",
    x1: 10,
    y1: 20,
    x2: 57,
    y2: 4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC736D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.142476,
    stopColor: "#DB5D58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E85576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.446912,
    stopColor: "#E4489C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.580759,
    stopColor: "#BE45AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#7B44BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855,
    stopColor: "#5671EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#739BF5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEikow);
export default __webpack_public_path__ + "static/media/eikow.89db791fd8180aa6c9ef9bdf5221df44.svg";
export { ForwardRef as ReactComponent };